import DOMPurify from 'dompurify';

/**
 * Sanitize mermaid-generated SVG before DOM injection via dangerouslySetInnerHTML.
 *
 * Default DOMPurify config already removes all XSS vectors:
 * - <script> elements
 * - event handler attributes (onclick, onload, etc.)
 * - javascript: / data: / file: URLs in href/xlink:href
 * - <foreignObject> (not in default SVG allowlist)
 *
 * ALLOW_DATA_ATTR preserves data-testid attributes that our component tests
 * depend on for querying rendered diagram elements.
 */
export function sanitizeSvg(svg: string): string {
  return DOMPurify.sanitize(svg, {
    ALLOW_DATA_ATTR: true,
  });
}
